import ky from 'ky';

const url = process.env.REACT_APP_API_HOST_URL;
const kyOriginal = ky.create({
    prefixUrl: url,
    throwHttpErrors: false,
    timeout: false,
    hooks: {
        afterResponse: [
            (_request, _options, response) => {
                if(response.status === 401) {
                    localStorage.removeItem('user_id');
                    localStorage.removeItem('token');
                    window.open(`https://${window.location.hostname}/login`, '_self');
                }
            }
        ]
    }
});

export default kyOriginal;